import { ICartRowItem } from "../../../Cart/types/ICartRowItem";
import { FindIntersect } from "../../../Helpers/FindIntersect";

export function RefreshModel (cartItems: Array<ICartRowItem>, arraysToUpdate: KnockoutObservableArray<any>[]) {
    console.debug("Cart items count", cartItems.length);

    let updateArray = (itemList, arrays: KnockoutObservableArray<any>[]) => {
        var matches = arrays.map((array) => {
            return FindIntersect(array(), itemList, key => key.ItemID);
        });

        console.debug("Cart matches in ItemArrays", matches);

        var matchedItems = [].concat(...matches);
        console.info("Item matches on page", matchedItems.length);

        // Update arrays with cart data
        arrays.forEach((koArray, i) => {
            if (koArray().length < 1) {
                return;
            }
            console.debug("Array to update", { arrayIndex: i, array: koArray() });
            // Go through each item in the array
            koArray().forEach((item, index) => {
                //Reset values
                item.AddedToCart(false);
                item.Quantity(0);
                item.UoMPrices().forEach((prices) => {
                    prices.QtySelected(0);
                    prices.QtySelected.setOriginalValue(0);
                    prices.IsInCart(false);
                });
                item.UMQtySelected(item.DefaultUMQty);

                // Go through the cart item matches
                matchedItems.forEach((cartItem) => {
                    if (item.ItemID === cartItem.ItemID) {
                        // Go through UoM list
                        item.UoMPrices().forEach((prices) => {
                            // Set the values to match the cart values
                            if (prices.UMQty === cartItem.UoMPackSize) {
                                prices.QtySelected(cartItem.QtyOrdered);
                                prices.QtySelected.setOriginalValue(cartItem.QtyOrdered);
                                prices.IsInCart(cartItem.QtyOrdered > 0);

                                console.debug("Item match compare", { Cart: cartItem, UoM: prices });
                                koArray.splice(index, 1, item);
                            }
                        })
                    }
                })

                // Create array of items in cart
                let uomInCart: any[] = item.UoMPrices().filter((x) => { return x.IsInCart() });

                // Stop if there is no match
                if (uomInCart.length < 1) {
                    return;
                }

                // Set the flag to true if any item in UoM list is added to cart
                item.AddedToCart(uomInCart.length > 0);

                // Select first matching UoM in cart
                let umQtySelected = uomInCart[0].UMQty || null;
                if (umQtySelected) {
                    item.UMQtySelected(umQtySelected);
                }

                // Set the quantity based on the above criteria
                let quantity = uomInCart[0].QtySelected() || null;
                if (quantity) {
                    item.Quantity(quantity);
                    item.Quantity.setOriginalValue(quantity);
                }

                koArray.splice(index, 1, item);
            });

            koArray.valueHasMutated();
            console.debug("Array after splicing in cart matches", koArray());
        })
    }

    return new Promise<void>((resolve) => {
        updateArray(cartItems, arraysToUpdate);
        resolve();
    });
};